<template>
  <div
    class="min-w-[170px] flex hover:border hover:border-neutral-500 rounded items-center max-h-[25px]"
  >
    <font-awesome-icon
      :icon="['fas', setIcons()]"
      class="text-center px-2 w-3"
    />
    <ZccSearchSelect
      id="person"
      :model-value="modelValue"
      @update:model-value="(value: any) => onInput(value)"
      :options="options ? options : []"
      :selectLabel="'selecteren'"
      :deselectLabel="'deselecteren'"
      :selectedLabel="'geselecteerd'"
      :placeholder="placeholder"
      :placeholder-is-selected="placeholderSelected"
      class="bg-transparent text-center max-h-[25px] h-[25px]"
      :loading="loading"
    >
    </ZccSearchSelect>
  </div>
</template>

<script setup lang="ts">
import ZccSearchSelect from "./generic/ZccSearchSelect.vue";
import { SelectOption } from "@planbord/shared/models";

const emit = defineEmits<{ (e: "update:modelValue", value: unknown): void }>();
const props = defineProps<{
  label?: string;
  options: SelectOption[];
  loading?: boolean;
  modelValue: unknown;
  placeholder: string | undefined;
  placeholderSelected: boolean;
  role?: string;
}>();

function onInput(value: string | null) {
  emit("update:modelValue", value);
}

function setIcons() {
  switch (props.role) {
    case "driver":
      return "truck-medical";
    case "nurse":
      return "user-nurse";
    default:
      return "user";
  }
}

</script>
